import "./index.css";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";

const container: any = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );
